import brandingConfig from '../config/branding.json';

/**
 * Get the complete branding configuration
 * @returns {Object} The complete branding configuration
 */
export const getBranding = () => {
  return brandingConfig;
};

/**
 * Get logo configuration
 * @returns {Object} Logo configuration including path, alt text, and dimensions
 */
export const getLogo = () => {
  return brandingConfig.logo;
};

/**
 * Get application name
 * @returns {string} The configured application name
 */
export const getAppName = () => {
  return brandingConfig.appName;
};

/**
 * Get application tagline
 * @returns {string} The configured application tagline
 */
export const getAppTagline = () => {
  return brandingConfig.appTagline;
};

/**
 * Get branding colors
 * @returns {Object} Object containing primary and secondary colors
 */
export const getBrandingColors = () => {
  return brandingConfig.colors;
};